export default __webpack_public_path__ + "static/media/XLS.879b6732.svg";